<h1 class="page-title mb-5">الحقائق التجارية</h1>
<div>
  <div class="container-fluid">
    <div class="row">
      <div class="col-md-9">
        <p>
          ​​​​​​​​​​​​​​​​​​​​​​لا شك أن مصر سوق جاذبة للاستثمار ، وذلك بفضل
          المزيج الفريد من العوامل الديموغرافية والروابط التجارية مع العالم ، من
          موقع استراتيجي كبوابة تبادل تجاري لجنوب أوروبا و أفريقيا والشرق
          الأوسط, وعدد سكانها الذي يبلغ أكثر من 90 مليون نسمة يجعلها أكبر دولة
          عربية, ذلك بالإضافة إلى أن الحكومة قادرة على إطلاق حزمة جديدة من
          الحوافز للمستثمرين الجدد والقدامى.​
        </p>
        <p>
          وفيما يلي بعض الحقائق الرئيسية حول ممارسة الأعمال التجارية في مصر:
        </p>
        <div style="
            background-color: var(--color-gafi-border);
            border-right: 5px var(--color-primary) solid;
          " class="mb-4">
          <p style="font-size: 16px; color: var(--color-gray-444)" class="p-2">
            انخفاض معدل الضرائب والجمارك
          </p>
        </div>
        <p>النظام الضريبي:</p>
        <p>
          : في إطار جهود الحكومة المستمرة للارتقاء بالدولة المصرية لتصبح أكثر
          الوجهات جذبًا للاستثمار في منطقة الشرق الأوسط وشمال أفريقيا، قامت
          الحكومة بوضع قانون الضرائب حيث خفضت معدلات الضرائب على الشركات
          المساهمة و شركات الافراد الي 22.5 %، ومعدل ضريبة المبيعات / ضريبة
          القيمة المضافة 14 ٪.
        </p>
        <p>النظام الجمركي :</p>
        <p>
          في إطار مساعيها لتحسين مكانة مصر كمحورٍ عالمي للتصنيع، فإن التعريفة
          الجمركية تراوح من 0 إلى 30٪ وفقا لدرجة التصنيع ومن 0 إلى 10٪ على
          الآلات والمعدات المستخدمة في التصنيع
        </p>
        <div style="
            background-color: var(--color-gafi-border);
            border-right: 5px var(--color-primary) solid;
          " class="mb-4">
          <p style="font-size: 16px; color: var(--color-gray-444)" class="p-2">
            الخدمات المالية
          </p>
        </div>
        <p>
          لإصلاحات التي تمت في هذا القطاع خلال الأعوام الماضية أثرت إيجابيًا على
          الاقتصاد، حيث زاد التأكيد على الدور الذي يضطلع به البنك المركزي المصري
          وتعزيز القطاع المصرفي من خلال باقةٍ من الأساليب تتنوع بين عمليات الدمج
          والخصخصة. وقد أقام البنك المركزي المصري نظامًا مصرفيًا أكثر رصانةً
          وأعلى كفاءةً شمل تحسين قوانين احتياطي رأس المال وتشجيع الاندماجات
          والاستحوازات، مع تطوير جهازه الرقابي والتنظيمي ومعالجة ملفات القروض
          المصرفية غير العاملة. القطاعات التي شهدت نموًا متزايدًا للمنتجات
          المالية غير المصرفية تشمل التمويل العقاري والتأجير التمويلي ومنتجات
          الدخل الثابت والتخصيم والتأمين الهيئة العامة للرقابة المالية, تختص
          بالرقابة والإشراف على الأسواق والأدوات المالية غير المصرفية بما في ذلك
          أسواق رأس المال، وبورصات العقود الآجلة، وأنشطة التأمين، والتمويل
          العقاري والتأجير التمويلي والتخصيم والتوريق، بهدف تحقيق سلامة واستقرار
          تلك الأسواق والأدوات وتنظيم الأنشطة وتنميتها وتعظيم قدرتها التنافسية
          على جذب المزيد من الاستثمارات المحلية والأجنبية، وتعمل على الحد من
          مخاطر عدم التنسيق ومعالجة المشاكل التي تنتج عن اختلاف الطرق أو
          الأساليب الرقابية. هيئة سوق المال, هي الجهة المنظمة للسوق والمسؤولة عن
          ضمان تطوير سوق شفاف وآمن للمستثمرين. فقد ظلت محتفظة بقوتها بفضل وجود
          بورصةٍ هي الأطول عمرًا في منطقة الشرق الأوسط وشمال أفريقيا، بل والأحدث
          على مستوى هذه المنطقة: فالبورصة المصرية - التي عادةً ما يرمز إليها
          بالأحرف الأولى EGX- تعد من أفضل البورصات العالمية من حيث الأداء منذ
          العام 2003. وقد أصبحت البورصة المصرية -وهي أقدم سوقٍ للأسهم في منطقة
          الشرق الأوسط وشمال أفريقيا - أول عضوٍ في الاتحاد العالمي للبورصات عام
          2005 في اعترافٍ بمدى التطور والانضباط التنظيمي في مصر. قامت هيئة سوق
          المال بإنشاء بورصة النيل عام 2007 وهي أول بورصةٍ متخصصةٍ للمشروعات
          الصغيرة والمتوسطة في المنطقة.وحيث أن المشروعات الصغيرة والمتوسطة هي
          عمود الاقتصاد المصري , فإن بورصة النيل تمكن المشروعات الصغيرة
          والمتوسطة من الحصول على التمويل، كما تعطي المستثمرين صورةً واضحةً عن
          الشركات التي يرغبون في الاستثمار بها، بالإضافة إلى إستراتجية واضحة
          للتخارج من السوق – حيث بات هذا الأمر من السهولة كعملية بيع الأسهم.
        </p>
        <div style="
            background-color: var(--color-gafi-border);
            border-right: 5px var(--color-primary) solid;
          " class="mb-4">
          <p style="font-size: 16px; color: var(--color-gray-444)" class="p-2">
            إعمال القوانين والتشريعات
          </p>
        </div>
        <p>
          شهدت الأطر التنظيمية والتأسيسية التي تحكم الاستثمار في مصر إصلاحًا
          شاملاً ومهمًا خلال السنوات الماضية، حيث اتخذت الحكومة خطواتٍ جريئةٍ
          لخفض البيروقراطية، ولجعل مصر – صاحبة أحد أقدم الاقتصادات في العالم –
          ضمن أبسط وأسهل البلدان في مجال ممارسة الأعمال. ومن بين أمثلة الإصلاحات
          وإجراءات الحماية التي تقوم على مفاهيم حماية حقوق الملكية والمساواة
          وسهولة ممارسة الأعمال ما يلي:
        </p>
        <ul>
          <li>خدمات سريعة لتسوية المنازعات لكافة المستثمرين</li>
          <li>التملك الأجنبي للشركات بنسبة 100%</li>
          <li>
            إعادة الأرباح وأرباح الأسهم وتسوية المنازعات وآليات التسوية المنفذة
          </li>
          <li>
            المبادئ الشاملة لحوكمة الشركات وقوانين مكافحة غسيل الأموال ومنع
            الاحتكار وحماية المستهلك
          </li>
          <li>
            نظام المحاكم التجارية الجديد المعمول به حاليًا بجميع أنحاء الجمهورية
            لتسوية المنازعات
          </li>
          <li>اختصار زمن التأسيس من عدة أشهر في المتوسط إلى 72 ساعة فقط</li>
          <li>
            إقامة وتنفيذ نظام الشباك الواحد الذي يحتوي على عدد 53 جهة حكومية
            مختلفة يحتاجها المستثمر خلال تأسيسه لمشروعه، بالإضافة إلى إنشاء فروع
            لهذا الشباك في العديد من المحافظات في جميع أنحاء الجمهورية
          </li>
          <li>
            خفض سقف الحد الأدنى لرأس مال الشركات ذات المسؤولية المحدودة إلى 200
            جنيه مصري
          </li>
        </ul>
      </div>
      <div class="col-md-3">
        <app-fixed-go-on></app-fixed-go-on>
      </div>
    </div>
  </div>
</div>